import { Component, Inject, OnDestroy, OnInit, Renderer2 } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { HeaderService } from "src/app/components/header/header.service";
import { Observable, Subject, of } from "rxjs";
import { catchError, debounceTime, filter, shareReplay, switchMap, takeUntil, tap } from "rxjs/operators";
import { Papa } from "ngx-papaparse";
import { ConfirmDialogComponent } from "src/app/components/dialogs/confirm-dialog/confirm-dialog.component";
import { ShipmentSku } from "src/app/models/shipyard.model";
import { ShipyardService } from "src/app/modules/shipyard/shipyard.service";
import { SettingsService } from "src/app/services/settings.service";
import { UpdateSkuQtyComponent } from "src/app/modules/shipyard/shipments-detail/update-sku-qty/update-sku-qty.component";
import { PlanShipmentDialogComponent } from "src/app/modules/shipyard/shipments-list/plan-shipment-dialog/plan-shipment-dialog.component";
import { DialogActions } from '../dialog.model';
import { SnackbarComponent } from '../../snackbar/snackbar.component';

@Component({
  selector: "app-add-sku-dialog",
  templateUrl: "./add-sku-dialog.component.html",
  styleUrls: ["./add-sku-dialog.component.scss"],
})
export class AddSkuDialogComponent implements OnInit,OnDestroy {
  actions: DialogActions[];
  private _selectedSKU: ShipmentSku[] = [];
  get selectedSKU(): ShipmentSku[] {
    return this._selectedSKU;
  }
  private destroy$ = new Subject<void>();
  set selectedSKU(selectedSKU: ShipmentSku[]) {
    this._selectedSKU = selectedSKU;
    if(this.selectedSKU.length > 0) {
      this.actions[1].isDisabled = false;
      if(this.data?.isPrint) this.actions[2].isDisabled = false;
    } else {
      this.actions[1].isDisabled = true;
      if(this.data?.isPrint) this.actions[2].isDisabled = true;
    }
  }

  skuForm: FormGroup = new FormGroup({
    skuAutocomplete: new FormControl(),
    skuQty: new FormControl(1)
  });
  filteredOptions$: Observable<any>;
  account:string;
  importBulk: boolean;
  importBulkForm: FormGroup = new FormGroup({
    skuList: new FormControl(null, [Validators.required]),
  });
  invalidSkus: string[] = [];
  invalidFbatypeSkus: string[] = [];
  validatedSku:boolean = false;
  private ShipmentSkuList: ShipmentSku[] = [];
  currentselectedSKU: ShipmentSku[] = [];
  validatorSpin:boolean = false;
  prepByAmazon: FormControl;
  isWalmartAccount:boolean;
  replace:boolean = false;
  focus: boolean = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data,
    public dialogRef: MatDialogRef<AddSkuDialogComponent>,
    private shipyardService: ShipyardService,
    private dialog: MatDialog,
    private headerService: HeaderService,
    private papa: Papa,
    private snackBar: MatSnackBar,
    private settingsService: SettingsService,
    private renderer: Renderer2
  ) {
    this.headerService.accountSelectedType.pipe(takeUntil(this.destroy$))
    .subscribe((e) => {
      if (e) {
        this.isWalmartAccount = (e[0] === 'Walmart');         
      }
    });
  }

  ngOnInit(): void {
    this.currentselectedSKU = Object.assign([], this.data.selectedSKU);
    if (this.data.selectedSKU) {
      this.selectedSKU = this.data.selectedSKU;
    }
    this.importBulk = this.data.isCreateShipment ? this.data.importBulk : false;

    this.filteredOptions$ = this.skuForm.get('skuAutocomplete').valueChanges.pipe(
      debounceTime(300),
      switchMap(value => 
        this.shipyardService.TypeaheadSku(this.account, value, '', null, true).pipe(
          catchError(error => {
            console.error('Error fetching options', error);
            return of([]); // Return an empty array on error
          })
        )
      )
    );

    this.headerService.accountsSelected.pipe(takeUntil(this.destroy$)).subscribe((e) => (this.account = e[0]));
    this.actions = [
      { text: 'Cancel', buttonStyle: 'underline', spin: false },
      { text: 'Confirm', isDisabled: !this.selectedSKU.length, spin: false }
    ];
    if(this.data?.isPrint) this.actions.push({ text: 'Confirm & Print', isDisabled: !this.selectedSKU.length, spin: false });
  
    if (this.data['prepBy'] !== undefined) {
      this.prepByAmazon = new FormControl(this.data.prepBy ? 'true' : 'false');
      this.prepByAmazon.disable();
    }

    if(this.data?.hideQty) {
      this.skuForm.get('skuQty').clearValidators();
      this.skuForm.get('skuQty').updateValueAndValidity();
    } else {
      this.skuForm.get('skuQty').setValidators([Validators.required,Validators.pattern("^[0-9]*$")]);
      this.skuForm.get('skuQty').updateValueAndValidity();
    }
  }

  action(e) {
    if (e === "Confirm" || e === "Confirm & Print") {
      if (e === "Confirm") {
        this.actions[1].spin = true; 
      } else if (e === "Confirm & Print") {
        this.actions[2].spin = true; 
      }
      if (this.data && this.data.isCreateShipment || this.data.isAddSku) {
        this.dialogRef.close(this.selectedSKU);
        // this.createDraft();
      } else {
        const data = this.selectedSKU.map((e: ShipmentSku) => {
          return {
            sku: e.sku,
            qty: e.qty,
            accountSkuId:e.accountSkuId
          };
        });

        if (this.data.confirmationButton &&
            (this.data.confirmationButton === e || this.data?.isPrint) &&
            this.data.callBackFn) {
          this.data.callBackFn(this.dialogRef, data, this.actions, this.replace, e);
          if(!this.data.isSkuAdded) this.dialogRef.close();
        } else {
          this.dialogRef.close(data)
        }
      }
    } else {
      if (this.data && this.data.isCreateShipment) {
        this.dialogRef.close(this.currentselectedSKU);
        //this.createDraft(true);
      } else {
        if (this.importBulk) {
          this.importBulk = false;
          this.invalidSkus = [];
          this.invalidFbatypeSkus = [];
          this.validatedSku = false;
        } else this.dialogRef.close();
      }
    }
  }

  loadSku(res) {
    let foundSku = [];
    if (typeof this.skuForm.value.skuAutocomplete === 'string') {
      this.shipyardService
          .TypeaheadSku(this.account, this.skuForm.value.skuAutocomplete).pipe(takeUntil(this.destroy$))
          .subscribe((skus: ShipmentSku[]) => {
            foundSku = skus.filter((val) => val.sku === this.skuForm.value.skuAutocomplete);
            this.setSKuData(foundSku,res);
          });
    } else {
      this.setSKuData(foundSku,res);
    }
  }

  setSKuData(foundSku,res) {
    if (
        foundSku.length === 1 ||
        (this.skuForm.value.skuAutocomplete &&
            this.skuForm.value.skuAutocomplete.sku)
    ) {
      const sku =
          foundSku && foundSku.length
              ? foundSku[0]
              : this.skuForm.value.skuAutocomplete;
      sku.qty = this.skuForm.value.skuQty;
      sku.prep= res.prep;
      sku.fnSku = res.fnsku;
      sku.fbaType= this.skuForm.value.skuAutocomplete.fbaType ? this.skuForm.value.skuAutocomplete.fbaType : res.fbaType;
      sku.accountType= res.accountType;
      sku.length = res.length;
      sku.width = res.width;
      sku.height = res.hight;
      if (this.selectedSKU.some((b) => b.sku === sku.sku)) {
        const matchSku = this.selectedSKU.filter((b) => b.sku === sku.sku);
        matchSku[0].qty = +matchSku[0].qty + +sku.qty;
      } else {
        this.selectedSKU.push(sku as ShipmentSku);
      }
      this.skuForm.reset();
      this.skuForm.get("skuQty").setValue(1);
      this.ShipmentSkuList = [];
      this.actions[1].isDisabled = !this.selectedSKU.length;
      if(this.data?.isPrint) this.actions[2].isDisabled = !this.selectedSKU.length;
    } else {
      this.snackBar.openFromComponent(SnackbarComponent,
          {
            duration: 4000,
            horizontalPosition: 'center',
            data: {
              title: 'Invalid SKU, please try again',
              action: 'Dismiss',
              type: 'error',
            },
          }
      );
    }
  }

  displayWith(value: ShipmentSku) {
    if (value) {
      return value.sku;
    }
  }

  validateSkus() {
    if (
      this.importBulkForm.value.skuList &&
      this.importBulkForm.value.skuList.length
    ) {
      const data = (this.parseFromCsv(this.importBulkForm.value.skuList.trim())).filter((res) => {
        return res.sku != "";
     });
      this.validate(data);
    }
  }

  parseFromCsv(file) {
    const parsedData = this.papa.parse(file, {
      delimiter: "\t",
      complete: (result: any) => {},
    });

    const returnArray = parsedData.data.map((element) => {
      const qty= this.data.isCaseQty ?  (parseInt(element[2], 10)) * (parseInt(element[1], 10)) : parseInt(element[1], 10)
      const caseQty=this.data.isCaseQty ? (qty / (parseInt(element[1], 10))) : 0
      return {
        sku: element[0],
        caseQty: caseQty,
        qty:  qty,
      };
    });
    if (!returnArray[returnArray.length - 1].sku) returnArray.splice(-1, 1);
    return returnArray;
  }

  public validate(result: any) {
    this.validatorSpin = true;
    const data = {
      skuQtyList: result,
      account: this.account,
     // fulfillmentType: 'Fba',
    };
    this.shipyardService.ValidateBulkSkus(data).pipe(takeUntil(this.destroy$)).subscribe({
      next: (res:any) => {
        this.importBulkForm.reset();
        this.validatedSku = true;
        this.validatorSpin = false;
        if (res && res.invalidSkus && res.invalidSkus.length) {
          this.invalidSkus = res.invalidSkus;
          this.snackBar.openFromComponent(SnackbarComponent,
              {
                duration: 4000,
                horizontalPosition: 'center',
                data: {
                  title: `The following ${ this.invalidSkus.length } SKUS were not found : 
                  ${ this.invalidSkus.toString() }`,
                  action: 'Dismiss',
                  type: 'error',
                },
              }
          );
        }
        if (res.validSkus && res.validSkus.length) {
          res.validSkus.forEach((item) => {
            item.CaseQty = item.caseQty || 0;  
            if (!this.data.isCreateShipment && this.data.shipmentType) {
              const type = this.shipyardService.getShipmentTypeId(this.data.shipmentType);
              if (this.shipyardService.getShipmentTypeId(item.fbaType) === type) {
                this.selectedSKU.push(item as ShipmentSku);
                this.actions[1].isDisabled = !this.selectedSKU.length
                if(this.data?.isPrint) this.actions[2].isDisabled = !this.selectedSKU.length;
              } else {
                this.invalidFbatypeSkus.push(item.sku);
              }
            } else {
              this.selectedSKU.push(item as ShipmentSku);
            }
          });
          if (this.selectedSKU.length > 0) {
            this.actions[1].isDisabled = false;
            if(this.data?.isPrint) this.actions[2].isDisabled = false;
          }
        }
      },
      error: (err) => {
        this.validatorSpin = false;
        this.importBulkForm.controls.skuList.setErrors({ incorrect: true });
        this.snackBar.openFromComponent(SnackbarComponent,
            {
              duration: 5000,
              horizontalPosition: 'center',
              data: {
                title: 'Row(s) with invalid format. data must be Tab or Comma delimited',
                action: 'Dismiss',
                type: 'error',
              },
            }
        );
      }
     });
  }

  updateQty(sku) {
    this.dialog
      .open(UpdateSkuQtyComponent, {
        data: {
          title: "Update Quantity",
          inputLabel: "New Quantity",
        },
      })
      .afterClosed()
      .pipe(filter((e) => e))
      .subscribe((e) => {});
  }

  removeSku(sku) {
    const dialog = this.dialog.open(ConfirmDialogComponent, {
      width: "600px",
      data: {
        title: "Remove SKU",
        message: !this.data?.hideQty ? `Are you sure you want to remove ${sku.sku} from this shipment?` : `Are you sure you want to remove this sku ${sku.sku} ?`,
      },
    });
    dialog
      .afterClosed()
      .pipe(filter((e) => e === "Confirm"))
      .subscribe((e) => {
        this.selectedSKU = this.selectedSKU.filter(
          (currentSku) => sku.sku !== currentSku.sku
        );
        this.actions[1].isDisabled = !this.selectedSKU.length
        if(this.data?.isPrint) this.actions[2].isDisabled = !this.selectedSKU.length
      });
  }

  onPaste($event: ClipboardEvent) {
    const pastedText = $event.clipboardData.getData('text');
    this.skuForm.get('skuAutocomplete').setValue(pastedText);
  }

  createDraft(isClosed?) {
    this.dialog.open(PlanShipmentDialogComponent, {
      width: "720px",
      panelClass: "create-shipment",
      data: {
        warehouses$: this.settingsService.GetAllWarehouses().pipe(shareReplay()),
        isDraft: true,
        title: "Create Shipment",
        selectedSKU: isClosed ? this.currentselectedSKU : this.selectedSKU,
        shipmentTypeId:Number(this.data.shipmentTypeId)
      },
    });
  }

  back() {
    if (this.data && this.data.isCreateShipment) {
      this.dialogRef.close(this.selectedSKU);
      //this.createDraft();
    } else {
      this.importBulk = false;
    }
  }

  verifyAndLoadSku() {
    const data = {
      skuQtyList: [
        {
          sku: this.skuForm.value.skuAutocomplete.sku ?  this.skuForm.value.skuAutocomplete.sku : this.skuForm.value.skuAutocomplete,
          qty: this.skuForm.value.skuQty,
        },
      ],
      account: this.account,
    };
    this.shipyardService.ValidateBulkSkus(data).pipe(takeUntil(this.destroy$)).subscribe((res: any) => {
      if (res && res.validSkus && res.validSkus.length > 0) {
        const type = this.data.isCreateShipment
          ? this.data.shipmentTypeId
          : this.data.shipmentType;
        if (res.validSkus[0].fbaType?.toLowerCase() == type?.toLowerCase() || this.isWalmartAccount || this.data?.isAddSku) {
          this.loadSku(res.validSkus[0]);
          this.focus = false;
          this.renderer.selectRootElement('#skuAutocomplete').focus();
        } else {
          this.snackBar.openFromComponent(SnackbarComponent,
              {
                duration: 4000,
                horizontalPosition: 'center',
                data: {
                  title: `SKU's FBA type not matching, please try again.`,
                  action: 'Dismiss',
                  type: 'error',
                },
              }
          );
        }
      } else {
        this.snackBar.openFromComponent(SnackbarComponent,
            {
              duration: 4000,
              horizontalPosition: 'center',
              data: {
                title: 'Invalid SKU, please try again.',
                action: 'Dismiss',
                type: 'error',
              },
            }
        );
      }
    });
  }

  onChange(event){
    if(event.option.value){
      this.focus = false;
       this.renderer.selectRootElement('#qty').focus();
    }
  }

  change(event,name?){
    if(event.keyCode == 9 && name == "qty" ){
       this.focus = true;
    } else{
      this.focus = false;
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }
}
